import React, { Component } from 'react';
import { Form } from 'react-final-form';

import { isRequired } from '../../../utils/validation';
import {
  getSiteManagers,
  postSiteManagers,
  deleteSiteManager,
} from '../../../api/siteManagers';
import SelectField from '../../../components/Form/SelectField';
import { MARKETING_ROLES, SITE_CHOICES } from '../../../utils/constants';
import Loader from '../../../atoms/Loader';

class MarketingTab extends Component {
  state = {
    loading: true,
    error: null,
    sites: [],
    siteOptions: SITE_CHOICES,
    availableRoles: [],
  };

  getSites = async () => {
    const { id } = this.props;
    const data = await getSiteManagers();
    const sites = data.items.filter((item) => item.manager.id === id);
    this.setState({ sites, loading: false });
  };

  componentDidMount() {
    try {
      this.getSites();
    } catch (e) {}
  }

  handleSubmit = async (data) => {
    const { sites } = this.state;
    const { id } = this.props;
    this.setState({ loading: true });
    const site = sites.find((site) => site.site === data.site);
    data.roles = site ? [...site.roles, data.roles] : [data.roles];
    try {
      await postSiteManagers({ ...data, manager: id });
      await this.getSites();
    } catch (e) {
      const error = typeof e.request !== 'undefined'
        ? JSON.parse(e.request.response)
        : e.getMessage;
      this.setState({ error });
    }
  };

  updateRoles = (siteRoles) => {
    return MARKETING_ROLES
      .map((role) => {
        if (!siteRoles.includes(role.value)) {
          return role;
        }
      })
      .filter((x) => x !== undefined);
  };

  handleRemove = async (id) => {
    this.setState({ loading: true });
    await deleteSiteManager(id);
    await this.getSites();
  };

  render() {
    const { sites, siteOptions, loading } = this.state;
    let availableRoles = [];
    return (
      <Form
        onSubmit={this.handleSubmit}
        render={({ handleSubmit, values, modified }) => {
          const site = sites.find((site) => site.site === values.site);
          if (modified.site && site) {
            values.roles = null;
            availableRoles = this.updateRoles(site.roles);
          } else {
            availableRoles = MARKETING_ROLES;
          }
          return (
            <>
              <div className="columns">
                <div className="column">
                  <SelectField
                    name="site"
                    label="Sito"
                    placeholder="Sito"
                    options={siteOptions}
                    isLoading={!siteOptions.length}
                    validate={isRequired}
                  />
                </div>
                <div className="column">
                  <SelectField
                    name="roles"
                    label="Ruolo"
                    placeholder="Ruolo"
                    options={availableRoles}
                    isLoading={!availableRoles.length}
                    validate={isRequired}
                  />
                </div>
                <div
                  className="column"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <button
                    className="button"
                    style={{
                      backgroundColor: 'transparent',
                      borderColor: 'transparent',
                      color: 'green',
                    }}
                    onClick={handleSubmit}
                  >
                    <span className="icon is-small">
                      <i className="mi mi-add-circle" />
                    </span>
                  </button>
                </div>
              </div>
              {sites.map((site) => {
                return site.roles.map((role, roleIndex) => {
                  const roleObject = MARKETING_ROLES.find((r) => r.value === role);
                  const siteObject = siteOptions.find(
                    (s) => s.value === site.site,
                  );
                  return (
                    <div className="columns" key={site.id}>
                      <div className="column">
                        <p>{siteObject.label}</p>
                      </div>
                      <div className="column">
                        <p>{roleObject.label}</p>
                      </div>
                      <div
                        className="column"
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <button
                          className="button"
                          style={{
                            backgroundColor: 'transparent',
                            borderColor: 'transparent',
                            color: 'red',
                          }}
                          onClick={() => this.handleRemove(site.id)}
                        >
                          <span className="icon is-small">
                            <i className="mi mi-remove-circle" />
                          </span>
                        </button>
                      </div>
                    </div>
                  );
                });
              })}
              {loading && <Loader />}
            </>
          );
        }}
      />
    );
  }
}

export default MarketingTab;
